import { StrictMode, useEffect, useState } from 'react'
import type { VFC } from 'react'
import { Spacing } from '@opallabs/gem'
import {
  Button,
  ButtonSize,
  TextInput,
  ParagraphText,
} from '@opallabs/lapidary'
import type { SidebarProps } from '../types'

export type Props = Pick<SidebarProps, 'theme' | 'title'> &
  Readonly<{
    onChange(value: string): void
  }>

/**
 * @private Only for tests.
 */
export const labelText = 'Title'

const CHARACTER_LIMIT = 255

export const Title: VFC<Props> = ({ onChange, theme = 'light', title }) => {
  const [value, setValue] = useState<string>(title)
  const [valid, setValid] = useState<boolean>(value.length > 0)
  const [canSave, setCanSave] = useState<boolean>(false)

  useEffect(() => {
    const changed = value !== title
    setCanSave(changed && valid)
  }, [title, valid, value])

  return (
    <StrictMode>
      <div css={{ position: 'relative' }}>
        <ParagraphText
          id="edit-presentation-title"
          styleOverrides={{ marginBlockEnd: Spacing.S }}
        >
          Title
        </ParagraphText>

        <TextInput
          additionalAriaLabels={{
            'aria-labelledby': 'edit-presentation-title',
          }}
          initialValue={value}
          minLength={1}
          maxLength={CHARACTER_LIMIT}
          onChange={(value: string) => setValue(value)}
          onValidate={(valid: boolean) => setValid(valid)}
          styleOverrides={{
            // @note This value is manually determined and will need to
            // change if the button's text or appearance changes.
            container: { paddingInlineEnd: Spacing.S * 7 },
          }}
          theme={theme}
        />

        <Button
          buttonText="Save"
          variant="secondary"
          disabled={!canSave}
          onClick={() => onChange(value)}
          name="change-title"
          size={ButtonSize.Small}
          styleOverrides={{
            button: {
              position: 'absolute',
              insetBlockEnd: Spacing.XS,
              insetInlineEnd: Spacing.XS,
            },
          }}
          theme={theme}
        />
      </div>
    </StrictMode>
  )
}
Title.displayName = 'Hubble: Title ← Sidebar ← PresentationEditor'
